import "./components/app-header.js";
// import "./components/app-footer-alt";
import "./components/app-instagram";
import "./components/app-recipe-card";
import "./components/app-discount-coupon-form";
import "./components/app-newsletter-form";
import "./components/app-contact-form";
import "./components/app-zipcode-verify-form";
import "./components/app-product-price";
import "./components/app-distribution-form";

import Bubbles from "./modules/bubbles";
import RecipesCarousel from "./modules/recipes-carousel";
import StoreLogosCarousel from "./modules/store-logos-carousel.js";
import ProductGallery from "./modules/product-gallery";
import ProductQuantityInput from "./modules/product-quantity-input";
import StickyAddToCart from "./modules/sticky-add-to-cart";
import RecipesCategoriesCarousel from "./modules/recipes-categories-carousel";
import Accordion from "./modules/accordion";
import Cart from "./modules/cart";
import WholesaleRegisterForm from "./modules/wholesale-register-form";
import WholesaleForm from "./modules/wholesale-form";
import CouponFormModal from "./modules/coupon-form-modal";
import ContestForm from "./modules/contest-form";
import "./modules/packing-supplies-popover";
import "./modules/faqs";
import "./modules/checkout-warning";
import "./modules/footer";
import ts_init_copy_to_clipboard from "./modules/copy-to-clipboard.js";

// Initialize copy to clipboard on load
document.addEventListener('DOMContentLoaded', function () {
    console.log('DOMContentLoaded')
    ts_init_copy_to_clipboard();
});

new Bubbles;
new RecipesCarousel;
new StoreLogosCarousel;
new ProductGallery;
new ProductQuantityInput;
new StickyAddToCart;
new RecipesCategoriesCarousel;
new Accordion;
new Cart;
new WholesaleRegisterForm;
new WholesaleForm;
new CouponFormModal;
new ContestForm;
